import { atom } from "recoil";
import { TimeZone } from "../model";

export const timeZonesState = atom<TimeZone[]>({
  key: "timeZonesState",
  default: [],
});